// Import style
import './style.scss';

// Import utilities
import { restCall } from '@builder/common/utilities.js';

// Import utilities
const {
	debounce
} = _uo.utility;

/**
 * Listen to changes to the Title field and save it
 */
export default class RecipeTitle {
	/**
	 * Invokes method to listen to the Title field
	 * 
	 * @return {undefined}
	 */
	constructor() {
		// Listen field changes
		this.listenField();
	}

	/**
	 * Listen to the Title field
	 * 
	 * @return {undefined}
	 */
	listenField() {
		// Listen to changes to the title field
		this.$field.addEventListener( 'input', debounce( () => {
			// Save the title
			this.saveTitle();
		}, 1500 ) );
	}

	/**
	 * Save the title
	 * 
	 * @return {undefined}
	 */
	saveTitle() {
		// Set loading animation
		this.$wrapper.classList.add( 'uap-title--loading' );

		// Do REST call
		restCall(
			// Endpoint
			'change_post_title',

			// Data
			{
				// eslint-disable-next-line camelcase
				post_ID: UncannyAutomator.recipe.id,
				// eslint-disable-next-line camelcase
				post_title: this.title,
			},

			// On success
			( response ) => {
				// Stop loading
				this.$wrapper.classList.remove( 'uap-title--loading' );

				// Add success class
				this.$wrapper.classList.add( 'uap-title--success' );

				// Remove it after two seconds
				setTimeout( () => {
					this.$wrapper.classList.remove( 'uap-title--success' );
				}, 3000 );
			},

			// On fail
			() => {
				// Stop loading
				this.$wrapper.classList.remove( 'uap-title--loading' );

				// Output if the developer mode is enabled
				if ( UncannyAutomator.dev.developerMode ) {
					// eslint-disable-next-line no-console
					console.error( "Couldn't save the title" );
				}
			},

			// Settings
			{
				// Doesn't require the call to return the recipes_object property
				requiresRecipesObject: false
			}
		);
	}

	/**
	 * Returns the recipe title
	 * 
	 * @return {String} The recipe title
	 */
	get title() {
		return this.$field.value;
	}

	/**
	 * Returns the wrapper that contains the "Title" field
	 * 
	 * @return {Node} The wrapper
	 */
	get $wrapper() {
		return document.getElementById( 'titlewrap' );
	}

	/**
	 * Returns the field to set the title
	 * 
	 * @return {Node} The title field
	 */
	get $field() {
		return document.getElementById( 'title' );
	}
}
